import React from "react";
import Header from './Common/header';

/* 
 * Component which serves the purpose of a "root route component". 
 */
class Page extends React.Component {
    /**
     * Here, we define a react lifecycle method that gets executed each time 
     * our component is mounted to the DOM, which is exactly what we want in this case
     */

    /**
     * Here, we use a component prop to render 
     * a component, as specified in route configuration
     */
    render() {
        const PageComponent = this.props.component
        const { headerType, headerText } = this.props;
        return (
            <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                <Header headerType={headerType} headerText={headerText}></Header>
                   <div style={{width: '100%', height: 'calc(100% - 61px)',position: 'fixed', top: '61px'}}><PageComponent /></div>
            </div>
        )
    }
}

export default Page